import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/recheck.webp';
import screenshot_target from '../../../images/letterfunnel/emiliyanenevemo.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Emiliyan Enev-Emo"
      firstname="Emiliyan"
      companyname="ReCheck"
      competition="Circularise en LTO Network"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/emiliyanenevemo.js